<template>
	<v-sheet>
		<v-navigation-drawer :value="value" right scrollable app @input="$emit('input', $event)">
			<v-list-item>
				<v-list-item-avatar align="center">
					<v-img src="@/assets/images/avatars/practice.png"></v-img>
				</v-list-item-avatar>

				<v-list-item-content>
					<v-list-item-title>{{ usersName }}</v-list-item-title>
					<v-list-item-subtitle>{{ usersProfession }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

			<v-list dense>
				<template v-for="item in items">
					<v-list-item v-if="item.hidden" :key="item.title" value="item.active" link>
						<v-list-item-content>
							<v-list-item v-if="item.onClick" slot="item" color="primary" class="text-center" @click="item.onClick">{{ item.title }}</v-list-item>
							<v-list-item v-else slot="item" router :to="item.to" :href="item.href" :target="item.target" color="primary" class="text-center">{{
								item.title
							}}</v-list-item>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-list>

			<template #append>
				<div class="pa-2">
					<v-btn :loading="apiRequest" color="secondary" block @click="signOut">Sign Out</v-btn>
				</div>
			</template>
		</v-navigation-drawer>
	</v-sheet>
</template>

<script>
import store from '@/store';
import { getNavItems, authSignOut } from '@utils';

export default {
	name: 'AdminNavDrawer',

	props: {
		value: {
			type: Boolean,
			default: false,
		},
	},

	data: () => ({
		drawer: false,
		apiRequest: false,
	}),

	computed: {
		items() {
			return getNavItems(this.user.locale, this.tenant.settings.wallet.show);
		},

		usersProfession() {
			return store.getters.user?.profession || store.getters.user?.industry || null;
		},

		usersName() {
			return store.getters.user?.first_name || store.getters.user?.name || null;
		},
	},

	created() {
		this.user = store.getters.user;
	},

	methods: {
		async signOut() {
			this.apiRequest = true;
			await authSignOut();
			this.apiRequest = false;
		},
	},
};
</script>
